import React from "react";
import { Link } from 'react-router-dom';
import LegalPage, { LegalSection, LegalList } from './legal/LegalPage';


function cookies() {
  let cookie = [
    "Our Cookies: Our cookies are “first-party cookies”, and can be either permanent or temporary. These are necessary cookies, without which the Site won't work properly or be able to provide certain features and functionalities. Some of these may be manually disabled in your browser, but may affect the functionality of the Site.",
    "Personalization Cookies: Personalization Cookies are used to recognize repeat visitors to the Site. We use these cookies to record your browsing history, the pages you have visited, and your settings and preferences each time you visit the Site.",
    "Security Cookies: Security cookies help identify and prevent security risks. We use these cookies to authenticate users and protect user data from unauthorized parties.",
    "Site Management Cookies: Site management cookies are used to maintain your identity or session on the Site so that you are not logged off unexpectedly, and any information you enter is retained from page to page. These cookies cannot be turned off individually, but you can disable all cookies in your browser.",
    "Third-Party Cookies: Third-party cookies may be placed on your computer when you visit the Site by companies that run certain services we offer. These cookies allow the third parties to gather and track certain information about you. These cookies can be manually disabled in your browser.",
  ];

  return (
    <LegalPage
      seo={{
        title: "Cookies Policy",
        description: "The cookies and tracking technologies WayaQuick uses on its website, and how you can control them.",
      }}
      title="WayaQuick Cookies policy"
    >
      <LegalSection title="Introduction">
        <p>
          WayaQuick (“we” or “us” or “our”) may use cookies, web beacons,
          tracking pixels, and other tracking technologies when you visit our
          website, including any other media form, media channel, mobile
          website, or mobile application related or connected thereto
          (collectively, the “Site”) to help customize the Site and improve your
          experience. We reserve the right to make changes to this Cookie Policy
          at any time and for any reason. We will alert you about any changes by
          updating the “Last Updated” date of this Cookie Policy. Any changes or
          modifications will be effective immediately upon posting the updated
          Cookie Policy on the Site, and you waive the right to receive specific
          notice of each such change or modification. You are encouraged to
          periodically review this Cookie Policy to stay informed of updates.
          You will be deemed to have been made aware of, will be subject to, and
          will be deemed to have accepted the changes in any revised Cookie
          Policy by your continued use of the Site after the date such revised
          Cookie Policy is posted.
        </p>
      </LegalSection>

      {/* Same heading as the next section; the ids keep the two apart in the contents. */}
      <LegalSection id="about-cookies" title="Types of Cookies">
        <p>
          A “cookie” is a string of
          information which assigns you a unique identifier that we store on your
          computer. Your browser then provides that unique identifier to use each
          time you submit a query to the Site. We use cookies on the Site to,
          among other things, keep track of services you have used, record
          registration information, record your user preferences, keep you logged
          into the Site, facilitate purchase procedures, and track the pages you
          visit. Cookies help us understand how the Site is being used and improve
          your user experience
        </p>
      </LegalSection>

      <LegalSection id="types-of-cookies" title="Types of Cookies">
        <p>The following types of cookies may be used when you visit our website.</p>
        <LegalList items={cookie} />
      </LegalSection>

      <LegalSection title="Control of cookies">
        <p>
          Most browsers are set to accept cookies by default. However, you can remove or reject cookies in your browser’s settings. Please be aware that such action could affect the availability and functionality of the Site
        </p>
      </LegalSection>

      <LegalSection title="Other Tracking Technology">
        <p>
          In addition to cookies, we may use web beacons, pixel tags, and other tracking technologies on the Site to help customize the Site and improve your experience. A “web beacon” or “pixel tag” is a tiny object or image embedded in a web page or email. They are used to track the number of users who have visited particular pages and viewed emails, and acquire other statistical data. They collect only a limited set of data, such as a cookie number, time and date of page or email view, and a description of the page or email on which they reside. Web beacons and pixel tags cannot be declined. However, you can limit their use by controlling the cookies that interact with them.
        </p>
      </LegalSection>

      <LegalSection title="Privacy Policy">
        <p>
          For more information about how we use information collected by cookies and other tracking technologies, please refer to our <Link to="/privacy">Privacy Policy.</Link> This Cookie Policy is part of and is incorporated into our Privacy Policy. By using the Site, you agree to be bound by this Cookie Policy and our Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection title="Contact Us">
        <p>
          All access requests, questions, comments, complaints and other requests regarding the cookies policy should be sent to <a href="mailto:privacy@wayaquick.com">privacy@wayaquick.com.</a>
        </p>
        <p>We may request additional details from you regarding your complaints and keep records of your requests and resolution.</p>
      </LegalSection>
    </LegalPage>
  );
}

export default cookies;
